/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0-nightly.2026.9.6",
    versionName: "0.6.0-nightly.2026.9.6",
    versionChannel: "nightly",
    buildDate: "2026-09-06T00:17:33.665Z",
    commitHash: "a1dd7bbc180b6ee1cc2fcadf69e89c0e1c7477e6",
};
